
export default {
  setOptionList(rawDataList) {
    return rawDataList.map(rawData => {
      const {
        id: answerSettingItemId,
        name: title,
        has_remark,
        has_child,
        risk_level,
        answer_setting_items,
      } = rawData;
      let result = {
        answerSettingItemId,
        title,
        requiredRemark: has_remark === 1,
        hasSubOption: has_child === 1,
        risk: risk_level != null ? `${risk_level}` : null,
        subOptionList: [],
      };
      if (has_child) {
        const subOptionList = answer_setting_items.map(rawSubData => {
          const {has_remark, id: answerSettingItemId, name: title, risk_level} = rawSubData;
          return {
            answerSettingItemId,
            title,
            requiredRemark: has_remark === 1,
            risk: risk_level != null ? `${risk_level}` : null,
          };
        });
        result = {
          ...result,
          subOptionList,
        };
      }
      return result;
    })
  }
}